module.exports = __webpack_public_path__ + "img/lp-breathing.35f40b79.svg";